export default "__VITE_ASSET__BpHDdmy$__"